import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FormField, Input } from "@cp/ui";
import { completePasswordReset } from "../api/authApi";
import { AuthLayout } from "../components/AuthLayout";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    if (password.length < 8 || password !== confirmation) {
      setError(
        password.length < 8
          ? "Das Passwort muss mindestens 8 Zeichen enthalten."
          : "Die Passwörter stimmen nicht überein.",
      );
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await completePasswordReset(token, password);
      setDone(true);
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      setError(
        msg.includes("invalid or expired token")
          ? "Der Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen an."
          : msg.includes("rate limit")
            ? "Zu viele Versuche. Bitte warten Sie eine Minute."
            : msg,
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title={done ? "Passwort geändert" : "Neues Passwort festlegen"}
      description={
        done
          ? "Ihre Änderung wurde gespeichert. Auf anderen Geräten ist eine neue Anmeldung erforderlich."
          : "Vergeben Sie ein neues Passwort für Ihr Capital-Pilot-Konto."
      }
    >
      {done ? (
        <>
          <p className="account-message account-message--success">
            Ihr lokales Tresor-Kennwort bleibt unverändert.
          </p>
          <Link to="/login" className="btn-primary auth-form__submit">Jetzt anmelden</Link>
        </>
      ) : !token ? (
        <>
          <p className="account-message account-message--error" role="alert">Der Reset-Link ist unvollständig.</p>
          <Link to="/forgot-password" className="btn-primary auth-form__submit">Neuen Link anfordern</Link>
        </>
      ) : (
        <form className="auth-form" onSubmit={(event) => { event.preventDefault(); void submit(); }}>
            <FormField label="Neues Passwort" htmlFor="reset-password" required>
              <Input
                id="reset-password"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormField>
            <FormField label="Passwort wiederholen" htmlFor="reset-password-confirm" required>
              <Input
                id="reset-password-confirm"
                type="password"
                autoComplete="new-password"
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
              />
            </FormField>
            <button
              type="submit"
              className="btn-primary auth-form__submit"
              disabled={busy}
            >
              {busy ? "Passwort wird gespeichert …" : "Passwort speichern"}
            </button>
            {error ? <p className="account-message account-message--error" role="alert">{error}</p> : null}
        </form>
      )}
    </AuthLayout>
  );
}
